import { motion } from 'framer-motion'
import React from 'react'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import { useTranslation } from '@/hooks/useTranslation'

const Loading = () => {
    const [showMessage, setShowMessage] = useState(false)
    const { t } = useTranslation();

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowMessage(true)
        }, 5000)
        return () => clearTimeout(timer)
    }, [])

    return (
        <motion.div
            key="loading"
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className="w-full h-full text-white flex flex-col items-center justify-center text-[100px]"
        >
                <Image
                    src="/loading.webp"
                    alt="Loading"
                    width={100}
                    height={100}
                    className="animate-spin"
                />
            {showMessage && (
                <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    whileInView={{ opacity: [1, 0.5, 1] }}
                    transition={{
                        opacity: {
                            duration: 1,
                            repeat: Infinity,
                            repeatType: 'reverse',
                            ease: 'easeInOut',
                        },
                        y: { duration: 0.5, ease: 'easeOut' },
                    }}
                    className="absolute mt-60 text-[24px] text-center max-w-xl z-20 text-shadow-border shadow-yellow-200/20"
                >
                    {t("lobby.longLoading")}
                </motion.div>
            )}
        </motion.div>
    )
}

export default Loading